import { SessionStorageService } from '../session-storage.service';

export class BaseWrapperService {
  constructor(protected sessionStorageService: SessionStorageService = null) {  }

  getDataSetId() { return this.sessionStorageService?.getItem('selected-data-set-id') ?? ""; }
  getPatientIds() { return this.sessionStorageService?.getItem('recent-patients') ?? ""; }
}
